import { twMerge } from "tailwind-merge";

import Lighting from "shared/assets/svg/lightning.svg?react";
import { Badge } from "shared/ui/badge";

type Props = {
  className?: string;
  title: string;
  date: string;
  reward: number;
};

export const HistoryItem = (props: Props) => {
  const { className, title, date, reward } = props;

  return (
    <li
      className={twMerge(
        "list-none border-b border-b-black/5 px-3 py-3.5",
        className
      )}
    >
      <span className="text-balticSea/50 inline-flex text-xs">{date}</span>
      <div className="mt-1 flex justify-between text-sm font-medium">
        {title}{" "}
        <Badge>
          +{reward} <Lighting className="h-2.5 w-1.5" />
        </Badge>
      </div>
    </li>
  );
};
